module.exports = __webpack_public_path__ + "media/components/Influencers/Accounts/Edit/edit-0cedcb142c61e8221363dcd36792264b.png";